/** Mirror of backend logistics_dashboard_notification_tabs.pure.ts */

import { buildDashboardTabNotificationsPath } from "../utils/dashboardTabNotifications";

export const LOGISTICS_DASHBOARD_TAB_KEYS = [
  "overview",
  "rfqs",
  "quotations",
  "contracts",
  "deliveries",
  "invoices",
  "performance",
];

export const LOGISTICS_TAB_NOTIFICATION_TYPES = {
  rfqs: ["rfq_received"],
  quotations: ["logistics_quote_rejected"],
  contracts: ["logistics_quote_accepted", "logistics_handover_ready"],
  deliveries: [
    "logistics_delivery_stages_configured",
    "logistics_create_manifest",
    "logistics_transit_update",
    "logistics_manifest_submitted",
    "logistics_grn_created",
    "logistics_grn_accepted",
    "logistics_eway_generated",
    "logistics_create_grn",
  ],
  invoices: [
    "logistics_invoice_generated",
    "logistics_invoice_accepted",
    "logistics_invoice_paid",
    "logistics_complete_payment",
  ],
  performance: [],
};

const TYPE_TO_TAB = new Map();
for (const [tab, types] of Object.entries(LOGISTICS_TAB_NOTIFICATION_TYPES)) {
  for (const t of types) {
    TYPE_TO_TAB.set(t, tab);
  }
}

export function resolveLogisticsTabForNotificationType(notificationType) {
  const key = String(notificationType || "").trim().toLowerCase();
  return TYPE_TO_TAB.get(key) || null;
}

export function notificationBelongsToLogisticsTab(notification, tabKey) {
  if (!notification || !tabKey || tabKey === "overview") return true;
  if (String(notification.module_name || "") !== "logistics") return false;
  const resolved = resolveLogisticsTabForNotificationType(notification.notification_type);
  return resolved === tabKey;
}

export function buildLogisticsTabNotificationsPath(tabKey) {
  return buildDashboardTabNotificationsPath({ dashboard: "logistics", tabKey, moduleName: "logistics" });
}
